import { MouseEvent, createContext } from 'react';
import { TableFilterOptionItem, TableFilterOptions, TableFilters, TableFiltersChangeCallback } from '../filters/types';

interface TableFilterContextValues {
  filterOptions?: TableFilterOptions;
  selectedFilters: TableFilters;
  appliedFilters: TableFilters;
  resultsCount?: number;
  applyFilters: () => void;
  clearFilters: () => void;
  deleteFilter: (filterId: string, optionId: string) => void;
  changeFilters: (filterId: string, options: TableFilterOptionItem[]) => void;
  openFilters: (event?: MouseEvent<HTMLElement>) => void;
  closeFilters: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
  onFiltersChange?: TableFiltersChangeCallback;
  isFiltersLoading?: boolean;
}

const TableFilterContext = createContext<TableFilterContextValues | null>(null);
export default TableFilterContext;
